import { SpinnerFixedPosition } from '@stern-ui/ui';
import { useRoutes } from 'react-router-dom';

import { useFetchSessionQuery } from '@/api';
import { MAINTENANCE_MODE } from '@/config';
import { AUTH } from '@/features/auth/';
import { Maintenance } from '@/features/maintenance';
import { cookieConsentFeatureFlag } from '@/globalConsts';
import { loadCookieConsent } from '@/lib/analytics';

import { patientFacingRoutes } from './patientFacing';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

type ElementRoute = {
	match: {
		route: {
			doNotLoadAnalytics?: boolean;
		};
	};
};

export const AppRoutes = () => {
	const {
		data: session,
		error: sessionError,
		isLoading,
	} = useFetchSessionQuery(undefined, { skip: MAINTENANCE_MODE === 'true' });
	// check localStorage to ensure user has completed MFA (or not required to)
	const mfaAuthConfirmed =
		localStorage.getItem(AUTH.MFA.STORAGE_KEY) === AUTH.MFA.CONFIRMED_VALUE;
	const routes = session && !sessionError && mfaAuthConfirmed ? protectedRoutes : publicRoutes;

	const element = useRoutes([...routes, ...patientFacingRoutes]);

	const doLoadAnalytics = (element?.props as ElementRoute)?.match?.route?.doNotLoadAnalytics
		? false
		: true;

	if (MAINTENANCE_MODE === 'true') {
		return <Maintenance />;
	}

	if (isLoading) {
		return <SpinnerFixedPosition size='xl' variant='light' />;
	}

	if (cookieConsentFeatureFlag && doLoadAnalytics) {
		loadCookieConsent();
	}
	return <>{element}</>;
};
